import React from "react";
import styles from "./RouteSteps.module.css";

import { SideList } from "../SideList";

// Schematic itinerary of a Themenroute in the side column: route name and
// description, then its POIs (route_poi, in sort_order) as numbered steps
// with picture and text, connected by down arrows.
export default function RouteSteps({ route, steps, activeKey, onSelect }) {
  return (
    <SideList>
      <div className={styles.header}>
        <div className={styles.routeName}>{route.name}</div>
        {route.description && <p className={styles.routeDescription}>{route.description}</p>}
      </div>

      <ol className={styles.steps}>
        {steps.map((step, index) => (
          <li key={step.key} className={styles.stepItem}>
            {index > 0 && (
              <div className={styles.arrow} aria-hidden="true">
                ↓
              </div>
            )}

            <button
              type="button"
              className={
                activeKey === step.key ? `${styles.step} ${styles.stepActive}` : styles.step
              }
              onClick={() => onSelect(step)}
            >
              {step.imageUrl && <img src={step.imageUrl} alt="" className={styles.image} />}
              <span className={styles.body}>
                <span className={styles.title}>
                  <span className={styles.number}>{index + 1}</span>
                  {step.name}
                </span>
                {step.description && <span className={styles.text}>{step.description}</span>}
              </span>
            </button>
          </li>
        ))}
      </ol>
    </SideList>
  );
}
